<template>
<div class="chapter">
<div class="inner_page">
<div class="ad">
<p class="center"><a href="https://the-line-up.com/newsletters/?utm_source=TLUGOAAAAJ&amp;utm_campaign=9781453293447" target="_blank">
<img alt="image" src="html/image/tlu-backad.jpg"/></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tlu.vue?059ee80f